import { useState } from 'react';
import Reveal from '@/components/base/Reveal';

export default function SubscribeBand() {
  const [done, setDone] = useState(false);

  return (
    <section className="w-full bg-background-50 px-4 pb-16 md:px-8 md:pb-20">
      <Reveal className="mx-auto w-full max-w-7xl">
        <div className="relative overflow-hidden rounded-lg bg-primary-500 px-6 py-10 md:px-12 md:py-14">
          <div className="pointer-events-none absolute -right-10 -top-10 h-48 w-48 rounded-full bg-accent-400/30 blur-3xl" />
          <div className="relative flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
            <div className="max-w-2xl">
              <span className="font-label text-[11px] tracking-[0.24em] text-background-50/70 dark:text-foreground-950/70">
                FOLLOW / 追更
              </span>
              <h2 className="mt-3 font-heading text-2xl font-bold text-background-50 md:text-3xl dark:text-foreground-950">
                不想整夜刷帖？让条线自己更新
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-background-50/80 dark:text-foreground-950/80">
                点一下订阅入口，本夜有新的塌房、翻车、争议、丑闻条线更新时，
                会按你关注的标签归到同一处，打开就是完整全貌。
              </p>
            </div>
            <div className="flex shrink-0 flex-col gap-3 sm:flex-row lg:flex-col xl:flex-row">
              <button
                type="button"
                onClick={() => setDone(true)}
                className="flex h-12 items-center justify-center gap-2 rounded-md bg-foreground-950 px-6 text-sm font-semibold whitespace-nowrap text-background-50 transition-colors hover:bg-foreground-900"
              >
                <i className="ri-notification-3-line text-base" />
                {done ? '已加入追更（示例）' : '加入追更提醒'}
              </button>
              <a
                href="#brief"
                className="flex h-12 items-center justify-center gap-2 rounded-md border border-background-50/40 px-6 text-sm font-semibold whitespace-nowrap text-background-50 transition-colors hover:bg-background-50/10 dark:border-foreground-950/30 dark:text-foreground-950"
              >
                先看今夜清单
              </a>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
}